export class Multidestino {
  idCliente: number;
  idPromoActivacion: string;
  pasajero: string;
  idPasajero:number;
  numeroContacto: string;
  kilometros: number;
  tarifa: number;
  Referencia:  string;
  emailPasajero:string;
  txtShowMarker: boolean;
  marker: any;
  ID:Number;
    index: number;
    indexLetra : string
    direccion: string;
    direccionGeocode: string;
    latllng: google.maps.LatLng;
    estado: boolean;
    showReferencia: boolean;
    Instruccion:string;
    idSedeOrigen:number
    constructor() {
        this.txtShowMarker = false;
        this.showReferencia = false;
    }
}
